<template>
  <div class="ai">
    <!-- 头部区域 -->
    <div class="header">
      <!-- 引用header组件 -->
      <Header class="head"></Header>
      <div class="header-content">
        <div class="banner-content">
          <!-- 标题 -->
          <div class="banner-first-title">果蔬识别</div>
          <!-- 副标题 -->
          <div class="banner-second-title">
            {{ bannerSecond }}
          </div>
          <!-- 申请试用 -->
          <Apply :inputName="tit" :type="type" class="applybtn"></Apply>
        </div>
        <!-- 图片,用作flex占位 -->
        <div class="banner-img"></div>
      </div>
    </div>
    <!-- 正文 -->
    <div class="content">
      <!-- 功能演示 -->
      <div class="func product">
        <!-- 标题 -->
        <div class="product-title">
          <!-- 图片 -->
          <div class="product-title-img">
            <img src="../assets/img/ai/func.png" alt="" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="product-content">
          <!-- 果蔬识别体验 -->
          <div
            class="reg-img"
            v-bind:style="{
              background: '#333',
              backgroundImage: 'url(' + regbg + ')',
              backgroundRepeat: 'no-repeat',
              backgroundSize: regbgwidth + '% 100%',
              backgroundPosition: regbgpos + ' 0'
            }"
          >
            <div class="result-div">
              <v-textarea
                class="reg-result"
                name="reg-result"
                v-model="result"
                >{{ result }}</v-textarea
              >
            </div>
            <div class="btn-div">
              <el-button
                type="primary"
                class="btn"
                id="regbtn"
                :loading="loading"
                onclick="upload.click()"
              >
                {{ loading ? '上传中' : '上传图片' }}
              </el-button>
              <input
                type="file"
                @change="upload($event)"
                id="upload"
                filetype="image/*"
                accept=".jpg,.jpeg,.png,.bmp"
                style="display: none"
              />
            </div>
          </div>
          <!-- 视频区域 -->
          <div class="video-content">
            <!-- 左侧视频 -->
            <Video :mp="mp" :poster="poster" class="video"></Video>
          </div>
        </div>
      </div>
      <!-- 产品列表 -->
      <div class="product">
        <!-- 标题 -->
        <div class="product-title">
          <!-- 图片 -->
          <div class="product-title-img">
            <img src="../assets/img/ai/list.png" alt="" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="product-content">
          <el-carousel :interval="4000" type="card" height="400px">
            <el-carousel-item v-for="(item, index) in productList" :key="index">
              <img :src="item.img" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!-- 特色优势 -->
      <div class="feature">
        <!-- 标题 -->
        <div class="feature-title">
          <!-- 图片 -->
          <div class="feature-title-img">
            <img src="../assets/img/ai/advance.png" alt="" />
          </div>
        </div>
        <!-- 正文 -->
        <div class="feature-content">
          <div
            class="feature-item"
            v-for="(item, index) in featureList"
            :key="index"
          >
            <!-- 图片 -->
            <div class="item-img">
              <img :src="item.img" alt="" />
            </div>
            <!-- 名称 -->
            <div class="item-name">
              {{ item.name }}
            </div>
            <!-- 介绍 -->
            <div class="item-detail">
              {{ item.detail }}
            </div>
          </div>
        </div>
      </div>
      <!-- 支持交流 -->
      <div class="support">
        <!-- 标题 -->
        <div class="support-title">
          <!-- 图片 -->
          <div class="support-title-img">
            <img src="../assets/img/ai/contact.png" alt="" />
          </div>
        </div>
        <!-- 正文 -->
        <div class="support-content">
          <div
            class="support-item"
            v-for="(item, index) in supportList"
            :key="index"
          >
            <!-- 图片 -->
            <div class="item-img" @click="goDetail(item.path)">
              <img :src="item.img" alt="" />
            </div>
            <!-- 名称 -->
            <div class="item-name" @click="goDetail(item.path)">
              {{ item.name }}
            </div>
            <!-- 介绍 -->
            <div class="item-detail" @click="goDetail(item.path)">
              {{ item.detail }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 申请 -->
    <Solution :inputName="apply" :type="type"></Solution>
  </div>
</template>

<script>
// 引用申请试用和头部组件
import Apply from '../components/apply.vue'
import Header from '../components/header.vue'
import Solution from '../components/solution.vue'
import Video from '../components/video.vue'
// import axios from 'axios'
export default {
  components: {
    Apply,
    Header,
    Solution,
    Video
  },
  data() {
    return {
      tit: '申请试用',
      apply: 'AI识别申请试用',
      result: '识别结果\n香蕉    1.000\n丑蕉    0.000  \n菠萝    0.000',
      regbgwidth: '90',
      regbgpos: '50%',
      loading: false,
      bannerSecond:
        '识别近千种水果和蔬菜的名称，支持同时识别多样商品，可自定义返回识别结果，适用于农贸市场、超市、生鲜水果店等场景',
      formdata: new FormData(),
      regbg: require('../assets/img/ai/banana.jpg'),
      productList: [
        {
          name: '果蔬识别',
          content:
            '识别近千种水果和蔬菜的名称，适用于识别只含一种果蔬的识物，可自定义返回识别结果数，适用于农贸市场、超市、水果店等各类场景。',
          intro: '果蔬识别正式商用',
          img: require('../assets/img/ai/01.jpg')
        },
        {
          name: '品牌Logo识别',
          content: '识别超过2万类商品Logo，接口返回Logo名称',
          intro: '品牌Logo识别正式商用',
          img: require('../assets/img/ai/02.jpg')
        },
        {
          name: '植物识别',
          content:
            '识别超过2万类常见植物和近6千种花卉，接口返回植物名称及百科信息',
          intro: '植物识别正式商用',
          img: require('../assets/img/ai/03.jpg')
        }
        // {
        //   name: '通用物体和场景识别',
        //   content:
        //     '支持超过10万类物体和场景识别，返回图片内物体的名称及所对应的百科信息',
        //   intro: '通用物体和场景识别识别正式商用',
        //   img: require('../assets/img/ai/04.png')
        // }
      ],
      featureList: [
        {
          name: '支持定制化识别',
          img: require('../assets/img/ai/dingzhi.png'),
          detail:
            '可根据不同业务场景制定专属的AI识别能力如自定义花卉识别，满足非通用场景下的业务需求'
        },
        {
          name: '组合接口API调用',
          img: require('../assets/img/ai/api.png'),
          detail: '可通过入参自由选择需要的垂类识别服务'
        }
      ],
      // 支持交流
      supportList: [
        {
          name: '新手指南',
          img: require('../assets/img/ai/03/031.png'),
          detail:
            '找到适合您业务的AI技术能力，快速创建应用，开始便捷的开发之旅',
          path: '/doc?index=1'
        },
        {
          name: '技术文档',
          img: require('../assets/img/ai/03/032.png'),
          detail: '针对使用API的开发者，提供果蔬识别技术开发文档',
          path: '/doc?index=2'
        },
        {
          name: '论坛交流',
          img: require('../assets/img/ai/03/033.png'),
          detail: '与其他开发者交流产品使用心得，及时了解产品最新动态',
          path: '/doc'
        }
      ],
      // 规则
      rules: {
        userName: [
          { required: true, message: '请输入您的姓名或称呼', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入您的联系方式', trigger: 'blur' }
        ]
      },
      // 申请入参
      agriculturalFeedbackForm: {
        userName: '',
        contact: '',
        content: '', // 备注
        source: 3 // 反馈来源 0-消费者C端 2-官网智慧农贸 3-官网 AI识别
      },
      isOpenApply: false,
      isReady: false,
      mp: 'http://file.agricultural.fameveg.com/file/upload/web/2022-02-28/cd9ecb8283e641f7b05db6420bf3e45c.mp4',
      poster:
        'http://file.agricultural.fameveg.com/file/upload/web/2022-02-28/eadc54d3c87b4ca8bcc2968079e01a3c.png',
      // mp: 'https://file.agricultural.fameveg.com/file/upload/null/2021-07-19/c7f6e8cc098947848876d177d166104a.mp4',
      // poster:
      //   'https://file.agricultural.fameveg.com/file/upload/null/2021-07-19/3b9c37306ac048339a63d441618f9065.png',
      type: '3'
    }
  },
  created() {},
  methods: {
    // 跳转到其他页面
    goDetail(path) {
      // 解决点击当前页面报错问题
      if (path !== this.pathname) {
        this.$router.push(path)
      }
    },
    async upload(event) {
      // this.result = '正在识别...\n请稍候'
      if (event.target.files.length === 0) {
        return
      }
      var imgObj = event.target.files[0]
      console.log(imgObj)
      this.loading = true
      var img = window.URL.createObjectURL(imgObj)
      if (img.toString() === this.regbg.toString()) {
        this.loading = false
        return
      }
      this.regbg = img
      var that = this
      var reader = new FileReader()
      reader.readAsDataURL(imgObj)
      // this.formdata.append('b64', reader.readAsDataURL(imgObj))
      reader.onloadend = function () {
        var tmpimg = new Image()
        tmpimg.src = that.regbg
        var bgwidth = (500 * tmpimg.width * 100) / tmpimg.height / 900
        that.regbgwidth = bgwidth > 100 ? 100 : bgwidth
        that.formdata.append(
          'b64',
          reader.result.replace(/^data:image\/\w+;base64,/, '')
        )
        // console.log(reader.result)
        that.$http
          .post('/predict', that.formdata, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          })
          .then(function (res) {
            if (res.status !== 200) {
              alert('服务器忙')
              return
            }
            var retstr = '识别结果\n'
            res.data.forEach((element) => {
              retstr += element[0] + '    ' + element[1].toFixed(3) + '\n'
            })
            that.loading = false
            that.result = retstr
          })
          .catch(function (err) {
            this.loading = false
            alert(err)
          })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.ai {
  height: 100%;
}
// 头部区域
.header {
  height: 600px;
  width: 100%;
  background: url(../assets/img/ai/01.png) center no-repeat;
  background-size: cover;
  color: #fff;
  font-size: 22px;
  .header-content {
    display: flex;
    justify-content: center;
    .banner-content {
      width: 800px;
      color: #ffffff;
      padding: 43px;
      .banner-first-title {
        margin-top: 70px;
        font-size: 50px;
      }
      .banner-second-title {
        margin-top: 50px;
        font-size: 22px;
        margin-bottom: 60px;
        width: 500px;
      }
      .applybtn {
        position: relative;
        top: 10px;
        left: -150px;
      }
    }
    .banner-img {
      width: 600px;
    }
  }
}
.content {
  margin-top: 50px;
  // 产品列表
  .product {
    .product-title {
      width: 291px;
      margin: 0 auto;
      height: 150px;
      line-height: 180px;
    }
    .product-content {
      margin: 0 auto;
      width: 1300px;
      img {
        width: 678px;
        height: 310px;
      }
    }
  }
  // 功能
  .func {
    .product-content {
      width: 1000px;
      margin: 0 auto;
      .reg-img {
        margin: 0 auto;
        vertical-align: middle;
        text-align: center;
        width: 900px;
        height: 500px;
        border-radius: 4px;
        .btn-div {
          position: relative;
          width: 900px;
          height: 100px;
          background: #000000;
          top: 240px;
          background-color: rgba(0, 0, 0, 0.6);
          .btn {
            width: 30%;
            position: relative;
            top: 30px;
            background-color: #0073eb;
            border-color: #0073eb;
            font-size: 20px;
            color: #ffffff;
          }
        }
        .result-div {
          width: 150px;
          top: 50px;
          left: 650px;
          position: relative;
          background-color: #0073eb;
          text-align: left;
          border-radius: 10px;
          .reg-result {
            position: relative;
            left: 20px;
            line-height: 40px;
            font-size: 18px;
            color: #ffffff;
            white-space: pre-wrap;
          }
        }
        margin-bottom: 20px;
      }
      .video {
        width: 900px;
        margin: 0 auto;
      }
    }
  }
  // 特色优势
  .feature {
    .feature-title {
      width: 291px;
      margin: 0 auto;
      height: 150px;
      line-height: 180px;
    }
    .feature-content {
      margin: 0 auto;
      width: 1300px;
      display: flex;
      .feature-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 600px;
        .item-img {
          width: 184px;
          height: 184px;
        }
        .item-name {
          margin-top: 40px;
          color: #333;
          font-weight: 700;
          font-size: 28px;
        }
        .item-detail {
          margin-top: 40px;
          color: #999;
          font-size: 20px;
          width: 420px;
        }
      }
    }
  }
  // 支持交流
  .support {
    .support-title {
      width: 291px;
      margin: 0 auto;
      height: 150px;
      line-height: 180px;
    }
    .support-content {
      margin: 0 auto;
      width: 1300px;
      display: flex;
      justify-content: space-between;
      .support-item {
        width: 420px;
        height: 432px;
        border: 1px solid #d2d2d2;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 34px;
        box-sizing: border-box;
        .item-name {
          margin-top: 30px;
          color: #333;
          font-size: 22px;
        }
        .item-detail {
          margin-top: 40px;
          color: #666;
          font-size: 18px;
        }
      }
    }
  }
  // 申请
  .solution {
    background-color: #fff;
    height: 500px;
    margin: 0 auto;
    .solution-title {
      margin: 0 auto;
      height: 160px;
      line-height: 160px;
      width: 550px;
      display: flex;
      color: #333;
      font-size: 40px;
    }
    .solution-form {
      margin: 40px auto;
      width: 900px;
      .input {
        width: 500px;
      }
      .forward {
        margin: 20px auto 0 90px;
        width: 300px;
        height: 40px;
        line-height: 40px;
        background-color: orange;
        color: #fff;
        text-align: center;
        border-radius: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>
